<template>
  <div class="aboutContainer">
    <h1><v-icon>contacts</v-icon> {{ $t('menu.presentation') }}</h1>
    <div class="formBloq">{{ $t('presentation.description') }}</div>
    <div class="center">
      <iframe width="300" height="400" :src="$t('presentation.videoLink')"></iframe>
    </div>
    <div class="formBloq">
      {{ $t('presentation.reasonText') }}
      <div v-for="(reason,i) in reasons" :key="i"><v-icon>check</v-icon> {{ $t('presentation.' + reason) }}</div>
    </div>
    <div class="footSpace"></div>
  </div>
</template>

<script>
export default {
  name: 'Presentation',
  data: () => ({

    reasons: [
    'reason1',
    'reason2',
    'reason3',
    'reason4',
    'reason5',
    'reason6'
    ]
  }),
}
</script>

<style scoped>
  .aboutContainer {
    margin: 20px;
  }

  .formBloq {
    margin: 20px;    
  }

  .center {
    text-align: center;
  }

  .footSpace {
    height: 5px;
  }
</style>